import React, {useCallback, useContext, useEffect, useState} from "react";
import "./Exporter.css";
import {IBDDef} from "../BD";
import { saveTemp } from "../../services/editor";
import PublishForm from "./PublishForm";
import {UserContext} from "../../contexts/UserContext";
import Button from "../Button";
import { XMarkIcon } from '@heroicons/react/24/outline';

interface EditMode {
    isEditMode: boolean;
    postId?: number;
    authorId?: number;
    title: string;
    description: string;
    isCertified: boolean;
    isHidden: boolean;
    isVerbi: boolean;
    verbiWord: string;
}

interface ExporterProps {
    bdDef : IBDDef,
    onClose : () => void,
    editMode?: EditMode,
    onPublishSuccess?: (postId: number) => void
}

const Exporter : React.FC<ExporterProps> = ({bdDef, onClose, editMode, onPublishSuccess}) => {
    const [bdURL, setBDURL] = useState<string | null>(null);
    const {currentUser} = useContext(UserContext);

    const share = async () => {
        try {
            const {URL} = await saveTemp(bdDef);
            const bdBlob = await fetch(URL).then((response)=> {
                return response.blob();
            });
            const sharedData = {
                files: [
                    new File([bdBlob], 'bd.png', {
                        type: bdBlob.type
                    })
                ],
                title: "Ma Birds Dessinés",
                text: "Lisez ma BD créée sur https://www.birdsdessines.fr"
            };
            if(navigator.canShare(sharedData)){
                await navigator.share(sharedData);
            }
        }catch(error:any){
            console.error(error.name, error.message)
        }
    }

    const download = useCallback(async () => {
        try {
            const {URL} = await saveTemp(bdDef)
            setBDURL( URL );

        }catch(error:any){
            console.error(error.name, error.message)
        }
    }, [bdDef]);

    useEffect(() => {
        download().catch(console.error);
    }, [download]);

    return (
        <div className={"Exporter"}>
            <div className={"modal"}>
                <div className={"header"}>
                    <div className={"header-title"}>
                        <h2>Votre BD</h2>
                        <Button variant="secondary" size="medium" onClick={() => onClose()}>
                            <XMarkIcon className="icon" />Je veux corriger ma BD
                        </Button>
                    </div>
                    <div className={"header-actions"}>
                        {
                            (navigator.share !== undefined) &&
                            <Button variant="primary" size="medium" onClick={(e) => share()}>
                                Partager
                            </Button>
                        }
                        {
                            (bdURL !== null) &&
                            <Button 
                                variant="success" 
                                size="medium" 
                                onClick={() => {
                                    const link = document.createElement('a');
                                    link.href = bdURL;
                                    link.download = "Ma BD BirdsDessines.png";
                                    link.click();
                                }}
                            >
                                Télécharger
                            </Button>
                        }
                    </div>
                </div>
                <div className={"bdPreview"}>
                    {
                        (bdURL !== null) ? (
                            <img className={"bd"} src={bdURL} alt={"BD"}/>
                        ) : (
                            <div className={"bdPlaceholder"}>Génération de la BD en cours...</div>
                        )
                    }
                </div>
                {
                    currentUser !== null &&
                    <PublishForm bdDef={bdDef} editMode={editMode} onPublishSuccess={onPublishSuccess}/>
                }
            </div>
        </div>
    )
}

export default Exporter;